import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CountReviews = () => {
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("🔄 Récupération du nombre total de reviewers...");

    axios.get('http://localhost:8000/api/dashboard/reviews/par-reviewer')
      .then(response => {
        console.log("✅ Données reçues :", response.data);
        setTotal(response.data.total_reviewers);
        setLoading(false);
      })
      .catch(error => {
        console.error("❌ Erreur lors de la récupération :", error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Chargement...</p>;

  return (
    <div className="bg-white shadow-md rounded-md p-4 text-right max-w-sm mx-auto mt-4 border border-gray-200">
      <h2 className="text-lg font-bold mb-2 text-gray-700">إجمالي المقيمين</h2>
      <p className="text-2xl text-green-600 font-semibold">
        {total}
      </p>
    </div>
  );
};

export default CountReviews;
